import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TCNAgent {
	tcn_agent_id: string;
	billing_id: string;
	agent_username: string;
	agent_password: string;
}

interface DialerState {
	isDialerVisible: boolean;
	tcn_agent: TCNAgent | null;
};

const initialState: DialerState = {
	isDialerVisible: false,
	tcn_agent: null,
};

export const dialerStateSlice = createSlice({
    name: 'dialerStateSlice',
    initialState,
    reducers: {
		setDialerVisibility: (state, action: PayloadAction<boolean>) => {
			state.isDialerVisible = action.payload;
		},
		setTCNAgentDetails: (state, action: PayloadAction<TCNAgent>) => {
			state.tcn_agent = action.payload;
		}
    }
});

export const {
	setDialerVisibility,
	setTCNAgentDetails
} = dialerStateSlice.actions;

export default dialerStateSlice.reducer;